module.exports = __webpack_public_path__ + "80b704926c48ed1d2606a05792ddb3c4.svg";